import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Sidebar.css';
import avaLogo from '../assets/imgs/ava-avatar.png';
import { API_BASE_URL } from '../config';

// const API_BASE_URL = 'http://localhost:3001';

function Sidebar({ user, onLogout, isOpen = true, onClose }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${API_BASE_URL}/auth/logout`, {}, { withCredentials: true });
      onLogout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Logout anyway on client side
      onLogout();
      navigate('/login');
    }
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <img src={avaLogo} alt="AHV Logo" className="logo-icon-img" />
          {!isCollapsed && <span className="logo-text">AHV Digitizer</span>}
        </div>
        <button className="collapse-btn" onClick={toggleSidebar}>
          {isCollapsed ? '»' : '«'}
        </button>
      </div>

      <nav className="sidebar-nav">
        <NavLink to="/dashboard" className="nav-item">
          <span className="nav-icon">📊</span>
          {!isCollapsed && <span className="nav-text">Dashboard</span>}
        </NavLink>

        <NavLink to="/digitizer" className="nav-item">
          <span className="nav-icon">📄</span>
          {!isCollapsed && <span className="nav-text">Treatment Digitizer</span>}
        </NavLink>

        <NavLink to="/farms" className="nav-item">
          <span className="nav-icon">🏡</span>
          {!isCollapsed && <span className="nav-text">Farms Management</span>}
        </NavLink>

        <NavLink to="/treatments" className="nav-item">
          <span className="nav-icon">📋</span>
          {!isCollapsed && <span className="nav-text">Treatment Records</span>}
        </NavLink>

        {user && user.role === 'admin' && (
          <NavLink to="/users" className="nav-item">
            <span className="nav-icon">👥</span>
            {!isCollapsed && <span className="nav-text">Users</span>}
          </NavLink>
        )}

        <div className="nav-divider"></div>

        <NavLink to="/settings" className="nav-item">
          <span className="nav-icon">⚙️</span>
          {!isCollapsed && <span className="nav-text">Settings</span>}
        </NavLink>
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            {user?.fullName?.charAt(0) || 'U'}
          </div>
          {!isCollapsed && (
            <div className="user-details">
              <div className="user-name">{user?.fullName || 'User'}</div>
              <div className="user-role">{user?.role || 'user'}</div>
            </div>
          )}
        </div>
        <button className="logout-btn" onClick={handleLogout} title="Logout">
          <span className="nav-icon">🚪</span>
          {!isCollapsed && <span className="nav-text">Logout</span>}
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
